/**
 * Card footer — quota usage line only. No "N connected" recap: there's no
 * real connected/disconnected toggle here (the row action is a hard
 * Disconnect/remove, not a state to summarize), so a right-hand count would
 * just restate what the rows already show.
 */
import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../theme/untitled/icons/Icon";
import styles from "../IntegrationsPage.module.scss";

const Footer = ({ quota, disabledCount }) => {
  if (!quota) {
    return null;
  }

  const usedText = quota.unlimited
    ? "Unlimited integrations."
    : `${quota.used} of ${quota.limit} integrations used`;

  const warning = quota.unlimited
    ? null
    : disabledCount > 0
    ? `${disabledCount} disabled by your plan`
    : quota.atLimit
    ? "No integrations left — upgrade to connect another"
    : null;

  const leftOrWarning = warning ? (
    <span className={styles.footerWarning}>
      <Icon name="AlertCircle" size={16} />
      {warning}
    </span>
  ) : (
    <span>{quota.left} left</span>
  );

  return (
    <div className={styles.footer}>
      <span className={styles.footerLeft}>
        <span>{usedText}</span>
        {!quota.unlimited && (
          <>
            <span className={styles.footerDot}>·</span>
            {leftOrWarning}
          </>
        )}
        {warning && (
          <>
            <span className={styles.footerDot}>·</span>
            <Link to="/billing" className={styles.footerLink}>
              Upgrade plan
            </Link>
          </>
        )}
      </span>
    </div>
  );
};

export default Footer;
